<template>
  <b-container class="teacher-sidebar overflow-auto sidebar">
    <br>
    <br>
    <br>
    <div class="text-center">
      <h4> Class Information </h4>
      <b-dropdown
        id="classNameDropdown"
        split
        split-variant="outline-home-primary"
        variant="home-primary"
        :text="classData.name"
        block
        class="max-dropdown">
        <div v-for="teacherClass in classes" :key="teacherClass.class_id">
          <b-dropdown-item v-if="teacherClass.name !== classData.name" @click="changeClass(teacherClass)">{{teacherClass.name}}</b-dropdown-item>
        </div>
      </b-dropdown>
    </div>
    <br>
    <div>Class Name</div>
    <b-input-group>
      <template #append>
          <b-input-group-text v-b-tooltip.hover title="Save Class Name" class="clickable" @click="updateClassName()"><i class="fas fa-save"></i></b-input-group-text>
      </template>
      <b-form-input id="newClassName" :value="classData.name" size="sm" ></b-form-input>
    </b-input-group>
    <br>

    <div>Start Date</div>
    <b-input-group>
      <template #append>
          <b-input-group-text v-b-tooltip.hover title="Save Start Date" class="clickable" @click="updateStartDate()"><i class="fas fa-save"></i></b-input-group-text>
      </template>
      <b-form-input type="date" id="newStartDate" :max="currentEndDate" :value="classData.start_date" @change="v => currentStartDate = v" size="sm" ></b-form-input>
    </b-input-group>
    <br>

    <div>End Date</div>
    <b-input-group>
      <template #append>
          <b-input-group-text v-b-tooltip.hover title="Save End Date" class="clickable" @click="updateEndDate()"><i class="fas fa-save"></i></b-input-group-text>
      </template>
      <b-form-input type="date" id="newEndDate" :min="currentStartDate" :value="classData.end_date" @change="v => currentEndDate = v" size="sm" ></b-form-input>
    </b-input-group>
    <br>

    <b-popover target="popover-student" triggers="hover" placement="top" boundary="viewport">
      <p>
        Give this code to
        students to use on the
        'Library' page to join
        <b>{{classData.name}}</b>
        as a student.
      </p>
    </b-popover>
    <div>Student Code <i id="popover-student" class="fas fa-info-circle"></i></div>
    <b-input-group>
      <template #append>
        <b-input-group-text v-b-tooltip.hover title="Copy to Clipboard" class="clickable" @click="copyToClipboard(`student-code`)" size="sm"><i class="fas fa-clipboard"></i></b-input-group-text>
      </template>
      <b-form-input id="student-code" :value="classData.student_code" readonly size="sm" ></b-form-input>
    </b-input-group>
    <br>
    <b-popover target="popover-teacher" triggers="hover" placement="top" boundary="viewport">
      <p>
        Give this code to
        teachers/TAs to use on the
        'Library' page to join
        <b>{{classData.name}}</b>
        as a teacher.
      </p>
    </b-popover>
    <div>Instructor Code <i id="popover-teacher" class="fas fa-info-circle"></i></div>
    <b-input-group>
      <template #append>
        <b-input-group-text v-b-tooltip.hover title="Copy to Clipboard" class="clickable" @click="copyToClipboard(`teacher-code`)" size="sm"><i class="fas fa-clipboard"></i></b-input-group-text>
      </template>
      <b-form-input id="teacher-code" :value="classData.instructor_code" readonly size="sm" ></b-form-input>
    </b-input-group>

    <br>
    <b-modal ref="deleteModal" hide-footer>
      <template #modal-header="{ close }">
        <h5>Delete Class</h5>
        <div class="clickable" @click="close()">
          <i class="fas fa-times fa-lg"></i>
        </div>
      </template>
        <p class="text-center">Warning! When you delete the class <b>{{classData.name}}</b>, all class data, including members' PCS progress,
          will be lost.
        <br>
        <br>
        Do you wish to continue?</p>
      <div class="teacher-sidebar">
        <div class="align-right">
        <b-button
          variant="outline-home-primary"
          size="sm"
          @click="hideModal('deleteModal')"
        >Cancel</b-button>
        <b-button
          variant="home-primary"
          size="sm"
          @click="deleteClass(classData.class_id)">Confirm</b-button>
        </div>
      </div>
    </b-modal>
    <div class="text-center">
      <b-button  variant="outline-home-primary" class="button inline w-100" @click="showModal('deleteModal')">Delete Class</b-button>
      <br>
      <p> {{`${students.students.length} total member${students.students.length === 1 ? '' : 's'}`}}</p>
      <br>
      <h4> PCS Information </h4>
      <b-dropdown
        split
        split-variant="outline-home-primary"
        variant="home-primary"
        :text="pcsSelect.name"
        block
        :disabled="(pcsList.length <= 1)">
        <div v-for="pcs in pcsList" :key="pcs.pcs_id">
          <b-dropdown-item v-if="pcs.pcs_id !== pcsSelect.pcs_id" @click="changePCS(pcs)">{{pcs.name}}</b-dropdown-item>
        </div>
      </b-dropdown>
      <b-modal ref="addPCSModal" hide-footer>
        <template #modal-header="{ close }">
          <h5>Add PCS to Class</h5>
          <div class="clickable" @click="close()">
            <i class="fas fa-times fa-lg"></i>
          </div>
        </template>
        <!--TODO: This will be where the payment system for teachers will be added-->
          <b-form-checkbox-group
            id="checkbox-group"
            v-model="selectedPCSs"
          >
          <div v-if="otherPCSs.length > 0">
            <div>Select the Playable Case Studies to add to <strong>{{classData.name}}</strong></div>
            <b-form-checkbox v-for="(pcs, index) in otherPCSs.filter(pcs => pcs.visible)" :key="index" :value="pcs.pcs_id"> {{ pcs.name }}</b-form-checkbox>
          </div>
          <div v-else>
            <strong>{{classData.name}}</strong> has all Playable Case Studies available for purchase.
          </div>

          </b-form-checkbox-group>
          <br />
          <div class="teacher-sidebar">
            <div v-if="otherPCSs.length > 0" class="align-right">
            <b-button
              variant="outline-home-primary"
              size="sm"
              @click="hideModal('addPCSModal')"
            >Cancel</b-button>
            <b-button
              variant="home-primary"
              size="sm"
              :disabled="selectedPCSs < 1"
              @click="addPCSsToClass">Add</b-button>
            </div>
          </div>
        </b-modal>
      <br />
      <PhasesManager
        :pcsSelect="pcsSelect"
        :classSelect="classData"
        :updateSuccessful="updateSuccessful"
        :updateUnsuccessful="updateUnsuccessful"
      />
      <br />
      <br />
      <b-button variant="outline-home-primary" class="inline w-100" @click="showModal('addPCSModal')">+ Add PCS to Class</b-button>
    </div>
  </b-container>
</template>

<script>
 import axios from 'axios'
 import PhasesManager from './PhasesManager'
 import { mapState, mapActions } from 'vuex'
  export default {
    name: 'TeacherSideBar',
    components: {
      PhasesManager
    },
    data() {
      return {
        classes: [],
        selectedPCSs: [],
        currentStartDate: '',
        currentEndDate: '',
      }
    },
    // props: [
    //   'pcsSelect',
    //   'classData',
    //   'getClass',
    //   'students',
    //   'pcsList',
    //   'otherPCSs',
    //   'updatePcs',
    //   'showPhases',
    //   'readStudents',
    //   'updateSuccessful',
    //   'updateUnsuccessful'
    // ],
    created: function() {
      this.getClasses()
      this.currentStartDate = this.classData.start_date
      this.currentEndDate = this.classData.end_date
    },
    computed: {
      ...mapState('teacherClass', [
        'pcsSelect',
        'classData', 
        'students', 
        'pcsList',
        'otherPCSs'
      ]),
    },
    methods: {
      ...mapActions('teacherClass', ['refreshClass', 'updatePcs', 'getStudents', 'updateSuccessful','updateUnsuccessful']),
      getClasses: function() {
        axios.post('/api/get_classes')
          .then(response => {
            this.classes = response.data.reverse()
          })
      },
      changeClass: function(classData) {
        localStorage.setItem('class', classData.class_id)
        window.location.reload()
      },
      updateClassName: function() {
        axios.post('/api/update_class', {
          params: {
            name: document.getElementById('newClassName').value,
            id: this.classData.class_id
          }
        })
          .then(response => {
            this.refreshClass()
            if (response.status) {
              this.updateSuccessful( `Class Name Updated to ${document.getElementById('newClassName').value}`)
            }
            else {
              this.updateUnsuccessful( `Server Error`)
            }
          })
      },
      updateStartDate() {
        axios.post('/api/update_class', {
          params: {
            startDate: document.getElementById('newStartDate').value === '' ? "emptyDate" : document.getElementById('newStartDate').value,
            id: this.classData.class_id
          }
        })
          .then(response => {
            this.refreshClass()
            if (response.status) {
              if (document.getElementById('newStartDate').value === '') {
                this.updateSuccessful( `Start Date Removed`)
              }
              else {
                this.updateSuccessful( `Start Date Updated to ${document.getElementById('newStartDate').value}`)
              }
            }
            else {
              this.updateUnsuccessful( `Server Error`)
            }
          })
      },
      updateEndDate() {
        axios.post('/api/update_class', {
          params: {
            endDate: document.getElementById('newEndDate').value === '' ? "emptyDate" : document.getElementById('newEndDate').value,
            id: this.classData.class_id
          }
        })
          .then(response => {
            this.refreshClass()
            if (response.status) {
              if (document.getElementById('newEndDate').value === '') {
                this.updateSuccessful( `End Date Removed`)
              }
              else {
                this.updateSuccessful( `End Date Updated to ${document.getElementById('newEndDate').value}`)
              }
            }
            else {
              this.updateUnsuccessful( `Server Error`)
            }
          })
      },
      showModal: function(modalName) {
        // Get up to date students before adding pcs
        if (modalName === 'addPCSModal'){
          this.getStudents();
        }
        this.$refs[modalName].show()
      },
      hideModal: function(modalName) {
        this.$refs[modalName].hide()
      },
      deleteClass: function(id) {
        axios.post('/api/delete_class', {
          params: {
            class: id,
          },
        })
        .then((response) => {
          this.getClasses()
          this.hideModal('deleteModal')
          this.$router.push({ name: 'teacher' })
        })
      },
      changePCS: function(pcs) {
        localStorage.setItem('pcs', pcs.pcs_id)
        this.updatePcs(pcs)
      },
      copyToClipboard: function(codeToCopy) {
        let textBox = document.getElementById(codeToCopy)
          textBox.setAttribute('type', 'text')
          textBox.select()
          try {
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
             this.$bvToast.toast(`Copied ${textBox.value}`, {
              toaster: 'b-toaster-top-center',
              title: `Copy Successful`,
              variant: `success`,
              autoHideDelay: 3000,
            })
          } catch (err) {
             this.$bvToast.toast("Something went wrong",{
              toaster: 'b-toaster-top-center',
              title: `Copy Unsuccessful`,
              variant: `danger`,
              autoHideDelay: 3000,
            })
          }
      },
      addPCSsToClass: function() {
        axios.post('/api/teacher/add_pcs_to_class', {
          params: {
            ...this.classData,
            pcss: this.selectedPCSs,
            students: this.students.students
          },
        })
        .then((response2) => {
          this.hideModal('addPCSModal')
          if (response2.status){
            window.location.reload()
          }
        })
      }
    },
  }
</script>
<style scoped lang="scss">
.teacher-sidebar::v-deep {
  @import './teacherPanel.scss';
  .dropdown-menu.show {
    transform: translate3d(0px, 38px, 0px) !important;;
  }
  .max-dropdown {
    max-width: 240px;
  }
}
.sidebar {
  position: -webkit-sticky; /* Safari */
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 260px;
  background-color: white;
  z-index: 900;
  border-right: 1px solid lightgray;
}
.clickable:hover {
    cursor: pointer;
}
</style>
